export const webStyle = {
  xNum: "20",
  xPercent: "33%",
  headerX: "40%",
  numCol: 7,
  authX: "80",
};
